import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';

const CTABanner = () => {
  return (
    <section className="py-20 bg-primary dark:bg-secondary relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-72 h-72 bg-highlight/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-white/80 text-sm mb-6">
            <Sparkles size={16} />
            <span>Ready to start?</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6">
            Let&apos;s Build a Website That Represents Your Business
          </h2>

          <p className="text-white/70 text-lg mb-10 max-w-2xl mx-auto">
            Start with a free consultation. No commitment, no pressure — just honest advice on 
            what your business needs.
          </p>

          <motion.a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-primary font-semibold rounded-xl hover:bg-white/90 transition-all"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Start Your Project
            <ArrowRight size={18} />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
